import { useQuery, useMutation } from "@tanstack/react-query";
import { fetch4, fetch3, fetch5 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
  statusCode?: number;
  statusMessage?: string;
  error?: any;
}

// DRS shipments for swap
export const useFetchDRSShipmentsForSwap = (drsId: string) => {
  return useQuery({
    queryKey: ["shipmentforswap", drsId],
    enabled: !!drsId,
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/drs/shipments/for-swap/${drsId}`,
        "GET",
      );

      if (!res?.success) {
        throw new Error(res?.message || "Failed to fetch shipments");
      }

      return res.data; 
    },
  });
};

// Fetch DRS Swap Driver Route Code List
export const useFetchDRSSwapDriverRouteCodeList = (raiseReqDriverDriverRouteCode: string, excludeDriverId?: string) => {
  return useQuery({
    queryKey: ["driverroutecodelist", raiseReqDriverDriverRouteCode, excludeDriverId],
    queryFn: async () => {
      const queryParams = excludeDriverId ? `?excludeDriverId=${excludeDriverId}` : "";
      const res = await fetch3(
        `${url}/api/admin/DRS-swap/driver/list/route/${raiseReqDriverDriverRouteCode}${queryParams}`,
        "get",
      );
      if (!res || !res.data) {
        return res.message;
      }
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

type DRSSwapGeneratePayload = {
  oldDrsId: string;
  shipmentIds: string[];
};

// Post DRS swap Generate
export const useDRSSwapGenerateMutation = () => {
  return useMutation({
    mutationFn: async (payload: DRSSwapGeneratePayload) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/admin/DRS-swap`,
        payload,
      );
      if (!res.success) {
        throw res.message || "Something went wrong";
      }
      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ DRS Swap Generated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ DRS Swap Generate request failed:", error.message);
    },
  });
};

// Accept Driver DRS Swap Request
export const useAcceptDriverDRSSwapMutation = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/admin/DRS-swap/accept`,
        "PATCH",
        payload,
      );
      if (!res.success) {
        throw res.message || res?.error || "Something went wrong";
      }
      return res;
    },
    onSuccess: (data: any) => {
      console.log("Accept Request Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Accept Request  create request failed:", error.message);
      return error;
    },
  });
};
